import './App.css';
// import Disinfect from './components/disinfect/disinfect';
import Id from './components/idNew/id';
import Scenes from './components/scenesNew/scenes';
import gsap from 'gsap';
import ScrollSmoother from 'gsap/src/ScrollSmoother';
import { useEffect, useState } from 'react';
// import ImageFadeInLayout from './components/imageFadeInLayout/imageFadeInLayout';
// import Gallery from './components/gallery/gallery';
// import Gallery2 from './components/gallery2/gallery';
import CommonLayout from './components/commonLayout/commonLayout';
import Battery from './components/battery/battery';
import DisinfectVideo from './components/disinfectVideo/disinfectVideo';
import Header from './components/header/header';
import DisinfectParam from './components/disinfectParam/disinfectParam';
import OtherScenes from './components/otherScenes/otherScenes';
gsap.registerPlugin(ScrollSmoother);

let language = document.querySelector('meta[name="language"]').content;
document.getElementById('root').setAttribute('lang', language);
document.getElementById('root').classList.add('no-cn');

let json = {
  text1: '一键式随身消毒棒',
  text2: '智云消毒宝',
  text3: '观看视频',
  text4:
    '摄影师用拍摄工具完成影像作品创作，记录生活中的万千可能。工作中他们追求洁净舒适的环境，工作之余也注重安心健康的生活方式，<div class="mainText">智云关爱用户需求，敢于创造，敢想敢做，持续“MAKE IT REAL”，用心回馈每一份创作热情。</div>',
  text5: '生活中细菌无处不在！看似干净的衣物，',
  text6:
    '却是<div class="mainText">大肠杆菌、尘螨等有害病菌和微生物</div>的“聚集地”，极易引发皮肤过敏。',
  text7:
    '智云消毒宝将<div class="mainText">臭氧和负氧离子发生器集于一身</div>，通过高压激活臭氧片放电产生臭氧，同时利用尖端对空气放电，电离空气生成负离子。',
  text8:
    '最快<div class="mainText">4分钟</div>完成对物品表面、缝隙的消毒，杀菌率达<div class="mainText">99%</div>以上。',
  text9:
    '* 数据来源于广东省微生物分析检测中心分析检测报告，高浓度臭氧有一定刺激性气味，请勿长时间接触，以免引发不适；4分钟为手提包场景消毒时长；使⽤过程中，请勿堵塞消毒⽓体出⼝，以免影响消毒效果。',
  text10: '探索臭氧消毒祛味原理',
  text11: '臭氧+负氧离子，2大核心消毒技术',
  text12:
    '臭氧和负氧离子可在密闭空间中渗透到角落缝隙，360°无死角，让有害菌无处遁形，消杀更彻底。臭氧杀菌后在常温下会自动分解成氧气，不产生二次污染，无残留，安全且环保；负离子与空气中的尘埃粒子结合沉淀，消毒之余还能净化空气，一举多得。',
  text13: '小巧便携，3秒自动消毒',
  text14:
    '橙白撞色设计，时尚感十足；净重100g，仅口红大小，<div class="mainText">随身携带无压力。</div>',
  text15:
    '<div class="mainText">防误触旋转式开机</div>，扭一扭，轻松解锁；一键启动消毒，消毒场景秒切换，选择场景后3秒自动消毒。',
  text16: '手提包',
  text17: '双肩包',
  text18: '行李箱',
  text19: '更大空间',
  text20: '消毒祛味都可以',
  text21:
    '* 手提包（5L）臭氧释放时长4min、双肩包（20L）释放时长6min、行李箱（30L）释放时长8min、循环场景释放4min间隔2H之后再次释放。',
  text22: '智享安心生活',
  text23:
    '在生活环境中，有很多肉眼看不见的有害菌，接触这些有害菌后容易导致过敏或引发疾病，智云消毒宝让你随时随地灭菌祛味，轻松解决生活烦恼。',
  text24: '* 臭氧具有极强的氧化性和杀菌性能，请勿长期置于易氧化物品中使用。',
  text25: '孩童娱乐，无缝消毒',
  text26:
    '婴儿宝宝的玩具、贴身衣物等物品容易隐藏细菌，臭氧气体可以渗透进衣物、玩具缝隙和小角落，无缝消毒，全方位呵护宝宝健康。',
  text27: '杜绝过敏，“无菌”上妆',
  text28:
    '妹纸们常用的化妆刷、粉扑等用品不易清洁，容易滋生有害菌和尘螨，导致皮肤过敏，化妆盒秒变消毒神器，“无菌”上妆更安心。',
  text29: '上班通勤，包袋消毒',
  text30:
    '通勤包包或手提袋容易隐藏有害菌，将智云消毒宝放入包袋中，连同耳机、钱包、钥匙等小物品一起消毒，省时省力。',
  text31: '差旅户外，一键清洁',
  text32:
    '外出差旅或户外活动，箱包容易招惹有害菌，随时随地对箱包进行消毒，出行更安心。',
  text33: '潮鞋好物，专属呵护',
  text34:
    '日常鞋履鞋等穿搭好物也会滋生有害菌，放于较密闭的空间可以随时消毒，时刻呵护你的心选好物。',
  text35: '0耗材，循环工作9H 5min',
  text36:
    '续航不需要任何耗材，避免频繁更换；支持边充电边使用，持久消毒不耽误。',
  text37:
    '* 该数据为消毒宝开启循环场景进⾏消毒的条件下测试得出，⼯作时间为 9H 5min，实际⼯作时间因环境条件不同⽽有所差异；27次为智云实验室环境测试持续释放时间可供手提包场景使用的理论次数，请以实际使用情况为准。',
  text38: '循环场景下连续释放消毒',
  text39: '9H 5min',
  text40: '手提包场景可使用',
  text41: '27 次',
  text42: '续航持久不需耗材',
  text43: '0耗材',
};

function is_weixin() {
  var ua = navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true;
  } else {
    return false;
  }
}

let isWeiXin = is_weixin();

function App() {
  const [textData, setTextData] = useState(json);
  useEffect(() => {
    // ScrollSmoother.create({
    //   smooth: 1, // how long (in seconds) it takes to "catch up" to the native scroll position
    //   effects: true, // looks for data-speed and data-lag attributes on elements
    //   smoothTouch: 0.1, // much shorter smoothing time on touch devices (default is NO smoothing on touch devices)
    // });
  }, []);

  useEffect(() => {
    async function fetchData() {
      let response = await fetch(
        `https://www.zhiyun-tech.com/website/in18/xdb/${language}.json`,
      );
      if (response.ok) {
        let json = await response.json();
        function formatText(text) {
          if (text.indexOf('{') < 0 && text.indexOf('_') < 0) {
            return text;
          } else if (text.indexOf('{') >= 0) {
            let rightBrackets = text.indexOf('{');
            let leftBrackets = text.indexOf('}') + 1;
            let oldText = text.slice(rightBrackets, leftBrackets);
            let newText = `<div class="mainText">${text.slice(
              rightBrackets + 1,
              leftBrackets - 1,
            )}</div>`;

            return formatText(text.replace(oldText, newText));
          } else if (text.indexOf('_') >= 0) {
            let brackets = text.indexOf('_');
            let oldText = text.slice(brackets, brackets + 1);
            let newText = `<br />`;
            return formatText(text.replace(oldText, newText));
          }
        }

        for (let item in json) {
          json[item] = formatText(json[item]);
        }
        // console.log(json);
        setTextData(json);
      } else {
        // console.log('HTTP-Error: ' + response.status);
      }
    }

    fetchData();
  }, []);
  return (
    <div className="App">
      <Header
        textData={textData}
        language={language}
        isWeiXin={isWeiXin}
      ></Header>
      <DisinfectVideo textData={textData} />
      <Id textData={textData}></Id>
      <Scenes textData={textData} />
      <OtherScenes textData={textData}></OtherScenes>
      <Battery textData={textData} />
    </div>
  );
}

export default App;
